<template>
  <div class="rate-container">
    <div class="add-container">
      <div class="section-one">
        <p class="title">Edit Rate</p>
        <div class="row">
          <div class="col-md-7 col-12 pr-md-0">
            <primary-input
                    type="text"
                    name="rate table name"
                    class="field name-input pr-md-3"
                    v-model="rate_table.rate_table_name"
                    v-validate="'required'"
                    :class="{'input': true, 'is-danger': errors.has('rate table name')}"
                    placeholder="Enter text number"
            />
            <div
                    class="help is-danger"
                    v-if="errors.has('rate table name')"
            >{{ errors.first('rate table name') }}</div>

            <primary-select
                    type="text"
                    name="rate table type"
                    class="type type-select pr-md-3"
                    v-validate="'required'"
                    :value="rate_table.rate_table_type"
                    @input="handleRateTableTypeChange"
                    :class="{'input': true, 'is-danger': errors.has('rate table type')}"
                    placeholder="Rate table type"
                    :options="rateTypes"
            />
            <div
                    class="help is-danger"
                    v-if="errors.has('rate table type')"
            >{{ errors.first('rate table type') }}</div>

            <div class="d-flex flex-md-column flex-column-reverse">
              <loader :loading="loading" v-if="loading" class="loading" />
              <operator-component
                      @click.native="() => openVendor(operator, k)"
                      @update-rate-list="UpdateRate"
                      v-else
                      :class="{active: k === activeOperatorId}"
                      v-for="(operator, k) in operators"
                      :key="k"
                      :index="k"
                      :isActive="k === activeOperatorId"
                      :operatorProp="operator"
                      :country_list="country_list"
                      :rateType="rate_table.rate_table_type"
                      :vendorsLength="vendorsList.length"
                      :vendorsList="vendorsList"
                      :fromIndex="fromIndex"
                      class="mb-0"
              />

              <div class="create-operator" @click="addOperatorItem">
                <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
                  <path
                          d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                          id="path-1"
                  />
                </svg>
                <p>Add Operator</p>
              </div>
            </div>

          </div>
          <div class="col-md-5 col-12 pl-md-0">
            <div class="section-two h-100" v-if="!loading && rate_table.rates.length !== 0">
              <p class="title">ADD VENDOR PRODUCTS FOR {{ networkName ? networkName : '' }}</p>
              <vendor-component
                      v-for="(vendor, k) in vendorsList"
                      :key="k"
                      :index="k"
                      :vendor="vendor"
                      :fromIndex="k"
                      :oldList="oldList"
                      :ratesList="vendor.rateList"
                      :mobileNetworkId="operator.mobile_network_uuid"
                      :activeOperatorId="activeOperatorId"
                      :priceVendor="vendor.priceVendor"
                      :vendor_product_uuid="vendor.vendor_product_uuid"
                      @removeVendor="removeVendorItem"
              />
              <div class="create-operator" @click="addVendorItem">
                <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
                  <path
                          d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                          id="path-1"
                  />
                </svg>
                <p>Add Vendor products for {{ networkName ? networkName : '' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import getDataForProduct from "@/views/SystemAdmin/Products/mixins/getDataForProduct";

export default {
  name: "EditRate",
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    OperatorComponent: () =>
      import("@/components/Product/AddProductOperator.vue"),
    VendorComponent: () => import("@/components/Product/AddProductVendor.vue"),
    Loader: () => import("@/components/Loader.vue"),
  },
  mixins: [getDataForProduct],
  data: () => ({
    rateError: null,
    rateTypes: [
      { name: "Prefix", value: "prefix" },
      { name: "MNCMCC", value: "MNCMCC" },
    ],
    country_list: [],
    loading: true,
    filterByfield: "mobile_network_uuid",
    fromIndex: 0,
    oldList: [],
    vendorsList: [],
  }),
  computed: {
    ...mapGetters({
      rate_table: "rateTable/getRateTable",
      routing: "routing/getRouting",
      product: "products/getProduct",
      activeOperatorId: "rateTable/getActiveRateId",
      operators: "rateTable/getRates",
      operator: "rateTable/getActiveRate",
      mobileNetwork: "mobileNetwork/getMobileNetwork",
      mobileNetworks: "mobileNetwork/getMobileNetworkList",
      mobileNetworksTotal: "mobileNetwork/getTotal",
      allMobiileNetworks: "products/getAllMObileNetworks",
      rates: "rates/getRates",
      //testList: 'routing/getActiveVendors',
    }),
    routingId() {
      return this.product.routing_uuid;
    },
    rateTableId() {
      return this.product.rate_table_uuid;
    },
    networkName() {
      if (this.rate_table.rate_table_type === "prefix") {
        return this.operator.code;
      } else {
        return this.mobileNetwork.network_name;
      }
    },

    getOperatorsBy() {
      return this.rate_table.rates.map((item, index) => {
        return {
          code: item.code,
          mobile_network_uuid: item.mobile_network_uuid,
          price: item.price,
        };
      });
    },
    filterByMobileNetwork() {
      return this.operators.map((operator, index) => {
        const vendors = [];
        let field = "mobile_network_uuid";
        if (this.rate_table.rate_table_type === "prefix") {
          field = "code";
        }
        if (vendors.length) {
          this.setAllVendors({ vendors, index });
        }
        return this.routing.routes
          .filter((item) => item[field] === operator[field])
          .map((item) => {
            if (this.rate_table.rate_table_type === "prefix") {
              vendors.push({ vendor_product_uuid: item.vendor_product_uuid });
            } else {
              vendors.push({
                vendor_product_uuid: item.vendor_product_uuid,
                mobile_network_uuid: item.mobile_network_uuid,
              });
            }
          });
      });
    },
    filteredRates() {
      return this.rate_table.rates.map((operator) => {
        if (this.rate_table.rate_table_type === "prefix") {
          return { code: operator.code, price: operator.price };
        }
        return {
          code: operator.code,
          price: operator.price,
          mobile_network_uuid: operator.mobile_network_uuid,
        };
      });
    },
    addFieldsToVendors() {
      let currentAllVendors = [];

      if (this.rate_table.rate_table_type === "prefix") {
        currentAllVendors = this.allVendors.map((item, index) => {
          return item.map((i) => {
            let operator = this.operators[index];
            return { code: operator.code, type: "prefix", ...i };
          });
        });
      } else {
        currentAllVendors = this.allVendors;
      }
      return currentAllVendors;
    },
  },
  created: async function () {
    await this.getCountryList();
    await this.viewRateTable(this.product.rate_table_uuid);
    await this.viewRouting(this.product.routing_uuid);
    if (this.rate_table.rates.length === 0) {
      this.loading = false;
      return;
    }
    this.filterByfield =
      this.rate_table.rate_table_type === "prefix"
        ? "code"
        : "mobile_network_uuid";

    this.chageActiveOperatorId(this.rate_table.rates.length - 1);

    if (this.rate_table.rate_table_type === "MNCMCC") {
      await this.viewMobileNetwork(
        this.rate_table.rates[this.activeOperatorId].mobile_network_uuid
      );
    }

    this.init().then((data) => {
      this.loading = false;
    });
    this.vendorslist(true);
  },
  methods: {
    ...mapActions({
      addProduct: "products/addProduct",
      addRate: "rateTable/addRate",
      viewRouting: "routing/getRouting",
      chageActiveOperatorId: "rateTable/updateActiveRateId",
      addRoute: "routing/addRoute",
      editRateTable: "rateTable/editRateTable",
      viewMobileNetwork: "mobileNetwork/GetMobileNetwork",
      editRouting: "routing/editRouting",
      updateRates: "rates/updateRates",
      viewRateTable: "rateTable/getRateTable",
      viewMobileNetworks: "mobileNetwork/GetMobileNetworks",
      addMobileNetworkList: "products/addMobileNetworkList",
      setAllVendors: "products/setAllVendors",
      resetRateState: "rates/resetRateState",
      getRateList: "rates/getRateList",
    }),
    async UpdateRate() {
      this.vendorslist()
    },
    init: async function () {
      let dataAll = [];
      for (let i = 0; i < this.rate_table.rates.length; i++) {
        dataAll.push(
          await this.getMobileNetworkList(this.rate_table.rates[i], i)
        );
      }
      return dataAll;
    },
    async vendorslist(created = false) {
      if (!this.routing.routes) {
        return [];
      }
      let data = { code: this.networkName };
      let rateList = [];
      let price
      if (created) {
        let routing=this.routing.routes
        let operators=[...this.operators];
        for (let i=0 ;i<operators.length;i++) {
          rateList=[]
          let item=operators[i]
          let rates = await this.getRateList({
            code: item.mobile_network_uuid == null ? item.code : "",
            mobileNetworkId: item.mobile_network_uuid != null ? item.mobile_network_uuid : "",
          });
          console.log('rates - ', rates)
          if(rates.items.length==0){
            operators.splice(i,1)
            i--
            continue
          }
          rates.items.map((rate) => {
            rateList.push({
              name: rate.vendor_product_name,
              value: rate.vendor_product_uuid,
            });

            if (rate.vendor_product_uuid === routing[i].vendor_product_uuid) {
              price = rate.price;
            }
          });
            let vendor_product_uuid=routing[i].vendor_product_uuid
            this.vendorsList.push({ data, rateList,vendor_product_uuid:vendor_product_uuid,priceVendor:price });

        }
          console.log('vl', this.vendorsList)
      } else {
        // this.vendorsList = []
        console.log("asdasd")
        let rates = await this.getRateList({
          code:
            this.rate_table.rate_table_type == "prefix" ? this.networkName : "",
          rate_table_type: this.rate_table.rate_table_type,
          mobileNetworkId:
            this.rate_table.rate_table_type == "MNCMCC"
              ? this.operator.mobile_network_uuid
              : "",
        });
        rates.items.map((rate) => {
          rateList.push({
            name: rate.vendor_product_name,
            value: rate.vendor_product_uuid,
          });
        });
      this.vendorsList.push({ data, rateList });
      }
    },
    removeVendorItem(data) {
      this.vendorsList.splice(data, 1);
    },
    handleRateTableTypeChange(v) {
      this.rate_table.rate_table_type = v;
      this.filterByfield = v === "prefix" ? "code" : "mobile_network_uuid";

      this.resetRateState();
      if (this.operator.code || this.operator.mobile_network_uuid) {
        this.getRateList(this.operator, v);
      }

      if (v === "MNCMCC") {
        this.addMobileNetworkList({
          mobileNetworkList: [],
          index: this.activeOperatorId,
        });
      }
    },
    priceProp(vendor) {
      let price = null;
      this.rates.map((rate) => {
        if (rate.vendor_product_uuid === vendor.vendor_product_uuid) {
          price = rate.price;
        }
      });
      return price;
    },
    addVendorItem() {
      let route = {};
      let checkByField = null;

      if (this.rate_table.rate_table_type === "MNCMCC") {
        checkByField = "mobile_network_uuid";
      } else if (this.rate_table.rate_table_type === "prefix") {
        checkByField = "code";
      }

      route[checkByField] = this.operators[this.activeOperatorId][checkByField];
      let codeName = this.networkName;
      this.getRateList({ code: codeName }, this.rate_table.rate_table_type);

      this.addRoute(route);
      this.vendorslist();
    },
    openVendor: async function (operator, operator_id) {
      if (operator_id !== this.activeOperatorId) {
        await this.chageActiveOperatorId(operator_id);
        await this.getRateList(operator, this.rate_table.rate_table_type);
        if (this.rate_table.rate_table_type === "MNCMCC") {
          await this.viewMobileNetwork(operator.mobile_network_uuid);
        }
      }
    },
    getMobileNetworkList: async function (operator, index) {
      let res = await this.viewMobileNetworks({ country_code: operator.code });
      let result = await this.viewMobileNetworks({
        per_page: res.total,
        country_code: operator.code,
      });
      await this.addMobileNetworkList({
        mobileNetworkList: result.items,
        index,
      });
      await this.getRateList(operator, this.rate_table.rate_table_type);

      return result;
    },
    async getCountryList() {
      const { items } = await this.$store.dispatch("getCountryList", {});
      this.country_list = items.map((country) => ({
        name: country.nice_name,
        value: country.iso3,
      }));
    },
    addOperatorItem() {
      if (this.operators.length !== 0) {
        if (this.rate_table.rate_table_type === "prefix") {
          if (!this.operator.code || !this.operator.price) return;
        } else if (this.rate_table.rate_table_type === "MNCMCC") {
          if (!this.operator.mobile_network_uuid || !this.operator.price)
            return;
        }
      }
      this.addRate({});
    },
    postProduct: async function () {
      await this.addProduct(this.product);
    },
    addRateTable: async function () {
      const data = {
        rate_table_name: this.rate_table.rate_table_name,
        rate_table_type: this.rate_table.rate_table_type,
        rates: this.filteredRates,
      };

      await this.editRateTable({ rate_table_uuid: this.rateTableId, data });
    },
    addRoutings: async function () {
      // let vendors = this.addFieldsToVendors.reduce((flatten, arr) => {
      //   return [...flatten, ...arr];
      // });

      let type =
        this.rate_table.rate_table_type === "MNCMCC" ? "mcc/mnc" : "prefix";
      let vendors = this.routing.routes
        .filter((item) => item.vendor_product_uuid)
        .map((item) => ({ type, ...item }));

      vendors = vendors.map((item) => {
        if (this.rate_table.rate_table_type === "prefix") {
          return {
            code: item.code,
            type: item.type,
            vendor_product_uuid: item.vendor_product_uuid,
          };
        } else if (this.rate_table.rate_table_type === "MNCMCC") {
          return {
            mobile_network_uuid: item.mobile_network_uuid,
            type: item.type,
            vendor_product_uuid: item.vendor_product_uuid,
          };
        }
      });

      await this.editRouting({
        routing: { routes: vendors },
        id: this.routingId,
      });
    },
    filterObjectNullVaulesInArray(obj) {
      return obj
        .map((item) => {
          item = JSON.parse(JSON.stringify(item), (key, value) => {
            if (value == null || value == "" || value == [] || value == {})
              return undefined;
            return value;
          });
          return item;
        })
        .filter((item) => item.vendor_product_uuid);
      //.filter(item => Object.keys(item).length !== 0)
    },
    save: async function () {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }

      try {
        await this.addRateTable();
        await this.addRoutings();

        this.$success("Product has been added.");

        this.$router.push({ name: "system-admin-product" });

        return { isRateAdded: true };
      } catch (err) {
        this.$error(err);
      }
    },
    validate: async function () {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rate-container {
  font-family: "Helvetica Neue";
  .add-container {
    display: flex;
    padding: 15px 15px 15px 15px;
    box-sizing: border-box;
    width: 100%;
    height: fit-content;
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 18px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .section-one {
      width: 100%;
      .title {
        color: #000000;
        font-family: "Helvetica Neue";
        font-size: 16px;
        font-weight: 500;
        line-height: 30px;
        margin-bottom: 15px;
      }
      .name-input {
        margin-bottom: 20px;
      }
      .type-select {
        margin-bottom: 20px;
      }
      .create-operator {
        cursor: pointer;
        margin-top: 20px;
        margin-bottom: 1rem;
        height: 30px;
        width: fit-content;
        fill: #55616e;
        display: flex;
        align-items: center;
        align-self: flex-start;
        p {
          margin-left: 7px;
          margin-bottom: 0;
          color: #55616e;
          font-family: "Helvetica Neue";
          font-size: 14px;
          line-height: 25px;
        }
      }
      .active {
        background: #f8f9fe;
      }
      .loading {
        height: 200px;
      }
    }
    .section-two {
      padding: 15px;
      box-sizing: border-box;
      background-color: #f8f9fe;
      .title {
        color: #bdbfd8;
        font-family: "Helvetica Neue";
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 1px;
        line-height: 30px;
      }
      .vendor-container {
        display: flex;
        width: 100%;
        margin-bottom: 10px;
        .vendor-wrapper {
          display: flex;
          width: calc(100% - 55px);
          justify-content: space-between;
          .vendor-select {
            width: 60%;
          }
          .vendor-input {
            width: 37%;
          }
        }
        .close-button {
          display: flex;
          align-items: center;
          justify-content: center;
          fill: #55616e;
          margin-left: auto;
          svg {
            cursor: pointer;
          }
        }
      }
      .create-operator {
        cursor: pointer;
        margin-top: 20px;
        margin-bottom: 10px;
        height: 30px;
        width: fit-content;
        fill: #55616e;
        display: flex;
        align-items: center;
        align-self: flex-start;
        p {
          margin-left: 7px;
          margin-bottom: 0;
          color: #55616e;
          font-family: "Helvetica Neue";
          font-size: 14px;
          line-height: 25px;
        }
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .first {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
